module.exports = __webpack_public_path__ + "static/img/dq.c316653.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dq.png
// module id = bZaV
// module chunks = 1